module.exports = __webpack_public_path__ + "static/media/test12_3.2fb715b4.png";